import {
  SEARCH_RESULTS_PAGE,
  CSN_CERTIFIED_VIEW_FACT_TYPE,
  PRODUCT,
  FACT_VERSION,
  getPageUrl
} from '@/utils/analyticsClientHelper';
import type { CertifiedViewFact } from '@/analytics/models/cventAnalytics/CertifiedViewFact';
import type { CsnSearchVenue } from '@/models/CsnSearchVenue';
import type { MapView } from '@/constants/mapConstants';

const INDEX_OFFSET = 1;

export function getCertifiedViewFact(
  searchTerm: string,
  mapView: MapView,
  venueIndex: number,
  venue: CsnSearchVenue,
  environment: string
): Omit<CertifiedViewFact, 'event'> {
  const isMicrosite = venue.listingOwnerType === 'MICROSITE';
  return {
    type: CSN_CERTIFIED_VIEW_FACT_TYPE,
    product: PRODUCT,
    page: SEARCH_RESULTS_PAGE,
    env: environment,
    ver: FACT_VERSION,
    venue_data: isMicrosite
      ? 'null'
      : JSON.stringify({
          venue_id: venue.id,
          venue_code: venue.code,
          ad_type: venue.featuredLevel,
          ad_id: venue.listingCode,
          position: venueIndex + INDEX_OFFSET
        }),
    search_term: searchTerm,
    map_view: mapView,
    page_url: getPageUrl(),
    microsite_data: isMicrosite
      ? JSON.stringify({
          microsite_id: venue.id,
          microsite_page_id: venue.pageId,
          venue_id: 'null',
          venue_code: 'null',
          ad_type: venue.featuredLevel,
          ad_id: venue.listingCode,
          position: venueIndex + INDEX_OFFSET
        })
      : 'null'
  };
}
